export default {
  tip: {
    danger: 'thao tác này có rủi ro!',
    googleCode: 'Vui lòng nhập mã xác minh Google'
  },
  btns: {
    today: 'hôm nay',
    yesterday: 'Một ngày',
    tomorrow: 'ngày hôm sau',
    month: 'tháng này',
    lastMonth: 'tháng trước'
  },
  label: {
    form: {
      submitTime: ' thời gian đặt lệnh',
      merchatNo: ' tài khoản merchant',
      agentNo: ' bên thứ 3',
      merchatOrderNo: ' mã giao dịch',
      systemOrderNo: ' số hệ thống',
      channelType: ' phương thức thanh toán',
      callbackStatus: 'kết quả',
      orderStatus: 'trạng tháng giao dịch',
      patchStatus: 'trạng thái bù đơn', // comment 备注
      remark: ' nội dung',
      description: 'ghi chú', // comment 备注 :
      amountStart: ' số tiền lớn nhất và nhỏ nhất'
    },
    table: {
      // agentNo: "bên thứ 3",
      merchatNo: 'tài khoản merchant',
      systemOrderNo: 'số hệ thống',
      merchatOrderNo: 'mã đơn hàng', // comment 商户订单号 : mã đơn hàng
      channelType: 'phương thức thanh toán', // comment 通道类型 : loại thanh toán
      channelCode: 'viết tắt',
      submitAmount: 'số tiền yêu cầu',
      paymentAmount: 'nộp số tiền',
      handlingFee: 'chi phí', // comment 手续费 : phí
      callbackAmount: 'số tiền thực tế nhận được',
      remark: 'nội dung', // comment 描述: mô tả
      // callbackTime: "thời gian callback",
      payoutTime: 'thời gian thanh toán', // comment 订单支付时间 thời gian thanh toán đơn hàng
      description: 'ghi chú', // comment 备注 :
      callbackStatus: 'kết quả',
      orderStatus: 'trạng tháng giao dịch',
      dispensing: 'Pha chế',
      patchType: 'Loại bù đơn', // comment 备注
      patchStatus: 'trạng thái bù đơn', // comment 备注
      patcher: 'người bù đơn', // comment 备注
      nowAmount: 'thực nhận',
      autoPayout: 'Thanh toan tự động',
      channelCodes: 'Loại thanh toán'
    },
    list: {
      totalNumber: 'tổng số giao dịch thành công',
      totalSuccessMoney: 'tổng tiền giao dịch thành công',
      totalMoney: 'tổng tiền thực tế',
      totalfee: 'tổng phí',
      makeupAmount: 'Tổng số đơn hàng bổ sung'
    }
  },
  rules: {
    submitTime: 'thời gian đặt lệnh không được để trống!'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/orders.js